import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { View } from '@olxbr/design-system'

import Paper from '../../atoms/Paper'
import HRule from '../../atoms/HRule'
import LogoTitle from '../../molecules/LogoTitle'
import TextCallout from '../../molecules/TextCallout'
import ScrollView from '../../atoms/ScrollView'
import ChangePasswordExpiredLinkTemplate from '../../templates/ChangePasswordExpiredLinkTemplate'

import medias from '../../../util/medias'

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  margin: ${() => '64px auto'};
  max-width: 466px;
  ${medias.medium`
    margin: 0;
  `}
`

const HRuleWrapper = styled(View)`
  margin-top: 34px;
  margin-right: 0;
  margin-bottom: 28px;
  margin-left: 0;
`

export const ChangePasswordExpiredLinkPage = ({ email, onSuccess, onForgotPasswordClick }) => (
  <ScrollView>
    <Content>
      <Paper>
        <LogoTitle title="Recuperar senha" />
        <ChangePasswordExpiredLinkTemplate
          email={email}
          onSuccess={onSuccess}
          onForgotPasswordClick={onForgotPasswordClick}
        />
        <HRuleWrapper>
          <HRule />
        </HRuleWrapper>
        <TextCallout
          text="Comece a usar a OLX"
          linkText="Entrar"
          href="/acesso"
          direction="column"
          fontWeight={400}
        />
      </Paper>
    </Content>
  </ScrollView>
)

ChangePasswordExpiredLinkPage.propTypes = {
  onForgotPasswordClick: PropTypes.func,
  onSuccess: PropTypes.func,
  email: PropTypes.string,
}
